import React, { useState } from "react";
import { FiEdit } from "react-icons/fi";
import { IoDocumentLockOutline } from "react-icons/io5";
import DimensionModel from "../DimensionModel";
import { RiFileInfoLine } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa";
import { formatINR, formatINRShort } from "../../../../utils/formatINR";

const AcresAndCentsUnitTable = ({ units = [], onEdit, onAdd, totalUnitRow = 0 }) => {
  const tableRows = Array.from({ length: totalUnitRow }, (_, index) => {
    const unit = units[index] || null;
    return {
      id: unit?.id || `placeholder-${index}`,
      unitNo: unit?.unitNo || null,
      acres: unit?.ratePerAcres || null,
      cents: unit?.ratePerCent || null,
      ratePerAcres: unit?.ratePerSqft || null,
      ratePerGround: unit?.ratePerGround || null,
      ratePerCent : unit?.ratePerCent || null,
   //   guidelineAcrePrice: unit?.guidelineAcrePrice || "N/A",
      registrationCharge: unit?.registrationCharge || null,
      northDimension: unit?.northDimension || null,
      southDimension: unit?.southDimension || null,
      eastDimension: unit?.eastDimension || null,
      westDimension: unit?.westDimension || null,
      roadFacingSide: unit?.roadFacingSide || { id: "", name: "N/A" },
     // preferredLocationCharge: unit?.preferredLocationCharge || "N/A",
     ratePerSqft : unit?.ratePerSqft || null,
      statusName: unit?.unitStatus?.name || "Available",
      unitStatus: unit?.unitStatus || { id: "", name: "Available" },
      order: unit?.order || index + 1,
      isPlaceholder: !unit || unit.isArchived,
      vendorGuideline: unit?.vendorGuideline || null,
      governmentGuideline: unit?.governmentGuideline || null,
      roadFacing: unit?.roadFacing || null,
      notes : unit?.notes || null,
      sqft: unit?.sqft || null,
    };
  });

  const [selectedDimension, setSelectedDimension] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const getStatusStyles = (status) => {
    switch (status) {
      case "Available":
        return "border-[#399E79] border bg-green-50 text-green-800";
      case "Agreement":
        return "border-[#FFDF94] border bg-yellow-50 text-yellow-800";
      case "Booked":
        return "border-[#EE6C4D] border bg-red-50 text-red-800";
      default:
        return "border-[#2280FF] border bg-blue-50 text-blue-800";
    }
  };

  return (
    <div className="bg-white rounded-[10px] p-6 shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full ">
          <thead>
            <tr className="bg-gray-100  text-base text-center rounded-md">
              <th className="px-4 py-3 text-gray-700 font-medium">Unit No.</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Acres</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Cents</th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Rate Per Acre
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">
                Total Price
              </th>
              <th className="px-4 py-3 text-gray-700 font-medium">Status</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Action</th>
            </tr>
          </thead>
          <tbody>
            {tableRows.length > 0 ? (
              tableRows.map((row) => {
                const totalAcres = row.acres !== "N/A" && row.cents !== "N/A" ? 
                  (parseFloat(row.acres) + parseFloat(row.cents) / 100) : 0;
                const totalPrice = row.ratePerAcres !== "N/A" ? totalAcres * row.ratePerAcres : 0;
                
                return (
                  <tr
                    key={row.id}
                    className="border-b text-center border-gray-200 hover:bg-gray-50"
                  >
                    <td className="px-4 text-sm py-4">{row.unitNo || "N/A"}</td>
                    <td className="px-4 py-4 text-sm ">{row.acres || "N/A"}</td>
                    <td className="px-4 py-4 text-sm ">{row.cents || "N/A"}</td>
                    <td className="px-4 py-4 text-sm">{row.ratePerAcres || "N/A"}</td>
                    <td className="px-4 py-4 ftext-sm cursor-pointer" title={formatINR(totalPrice)}>
                      {formatINRShort(totalPrice)}
                    </td>
                    {/* <td className="px-4 py-4 text-sm">
                      {row.guidelineAcrePrice}
                    </td>
                    <td className="px-4 py-4 text-sm font-medium">
                      {row.registrationCharge}
                    </td> */}
                  
                    <td className="px-4 py-4">
                      <span
                        className={`px-3 py-1 text-xs rounded-full ${getStatusStyles(
                          row.statusName
                        )}`}
                      >
                        {row.statusName}
                      </span>
                    </td>
                    {row.statusName === "Available" ||
                    row.statusName === "N/A" ? (
                      <td className="px-4 py-4">
                        {row.isPlaceholder ? (
                          <button
                            onClick={() =>
                              onAdd({
                                order: row.order,
                                unitNo: "",
                                ratePerAcres: null,
                                ratePerCent: null,
                                ratePerSqft: null,
                                ratePerGround: null,
                                sqft: null,
                                guidelineAcrePrice: null,
                                northDimension: null,
                                eastDimension: null,
                                westDimension: null,
                                southDimension: null,
                                roadFacingSide: { id: "", name: "" },
                              //  preferredLocationCharge: null,
                                // roadWidth: null,
                                createdBy: "",
                                unitStatus: { id: "", name: "" },
                                propertyId: "",
                                statusName: "Available",
                                registrationCharge: null,
                                notes : "",
                                governmentGuideline: null,
                                vendorGuideline: null,
                                roadFacing: "",
                              })
                            }
                            className="p-1 px-2 bg-customGreen text-white rounded-md  transition-colors flex items-center justify-center"
                            aria-label="Add unit"
                          >
                            <span className="text-sm">Add</span>
                          </button>
                        ) : (
                          <button
                            onClick={() => onEdit(row)}
                            className="p-2 text-customGreen hover:bg-blue-50 rounded-md transition-colors"
                            aria-label="Edit unit"
                          >
                            <FiEdit size={20} />
                          </button>
                        )}
                      </td>
                    ) : (
                      <td
                        onClick={() => onEdit(row)}
                        className="text-center hover:text-customGreen flex mt-5  justify-center  items-center  text-2xl  cursor-pointer"
                      >
                        <FaRegEye />
                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr className="text-center">
                <td colSpan={7} className="py-8 text-gray-500">
                  No units found
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            {onAdd && (
              <tr>
                <td colSpan={7} className="px-4 py-4 text-center">
                  <button
                    onClick={() =>
                      onAdd({
                        order: tableRows.length + 1,
                        unitNo: "",
                        ratePerAcres: null,
                        ratePerCent: null,
                        ratePerSqft: null,
                        ratePerGround: null,
                        sqft: null,
                        //  guidelineAcrePrice: null,
                        northDimension: null,
                        eastDimension: null,
                        westDimension: null,
                        southDimension: null,
                        roadFacingSide: { id: "", name: "" },
                        roadWidth: null,
                        createdBy: "",
                        unitStatus: { id: "", name: "" },
                        propertyId: "",
                        registrationCharge: null,
                        vendorGuideline: null,
                        governmentGuideline: null,
                        roadFacing: "",
                        notes: "",
                        preferredLocationCharge: null,
                      })
                    }
                    className="px-4 py-2 bg-customGreen text-white rounded-md transition-colors flex items-center mx-auto"
                  >
                    Add New Unit
                  </button>
                </td>
              </tr>
            )}
          </tfoot>
        </table>
      </div>
      <DimensionModel
        isOpen={isOpen}
        row={selectedDimension}
        isClose={() => setIsOpen(false)}
      />
    </div>
  );
};

export default AcresAndCentsUnitTable;